import type React from 'react';
import { forwardRef } from 'react';

import { useGetLists } from '@vlabs/api/luna-api/client';
import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { validate } from '@vlabs/shared';

import { useWorkspaceFilters } from '../../useWorkspaceFilters';

function ListsFilterPopover(
  props: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useWorkspaceFilters();
  const getLists = useGetLists({ page_size: 1000 });
  const listsOptions = getLists.data?.lists?.map((list) => ({
    label: list.user_data,
    value: list.list_id,
  })) ?? [];

  const handleChange = (nextValue: string[]) => {
    updateFilters({
      top_matching_candidates_label: nextValue.length > 0 ? nextValue : undefined,
    });
  };

  const reset = () => updateFilters({ top_matching_candidates_label: undefined });

  return (
    <PopoverWithButton
      {...props}
      onClickReset={reset}
      ref={ref}
    >
      <OptionsFilter
        isCreatable
        name="top_matching_candidates_label"
        onChange={handleChange}
        options={listsOptions}
        validateProp={validate.UUIDValidator()}
        value={filters.top_matching_candidates_label ?? []}
        visibleCount={5}
      />
    </PopoverWithButton>
  );
}

const ListsFilterPopoverWithRef = forwardRef(ListsFilterPopover);
export { ListsFilterPopoverWithRef as ListsFilterPopover };
